var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPodium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.641 512H339.359C355.664 512 369.362 499.74 371.163 483.534L400 224H48L76.837 483.534C78.638 499.74 92.336 512 108.641 512ZM424 144H127.375C133.75 113.125 158.125 88.75 190.125 82.001C198.75 90.625 210.75 96 224 96L286.197 96C309.41 96 330.699 80.314 335.083 57.519C340.982 26.848 317.613 0 288 0H224C202 0 183.5 15 177.875 35.25C125.875 46.875 86.125 90.25 79.375 144H24C10.745 144 0 154.745 0 168V168C0 181.255 10.745 192 24 192H424C437.255 192 448 181.255 448 168V168C448 154.745 437.255 144 424 144Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodium);
export default __webpack_public_path__ + "static/media/podium.d6aa4f3b1a0317bbc82ec29a0c53510b.svg";
export { ForwardRef as ReactComponent };